define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var PhoneNumberProviderModel = /** @class */ (function () {
        function PhoneNumberProviderModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.Website = ko.observable();
            this.IsDeleted = ko.observable(false);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, PhoneNumberProviderModel.Mapping, self);
            }
        }
        PhoneNumberProviderModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new PhoneNumberProviderModel(options.data);
            }
        };
        return PhoneNumberProviderModel;
    }());
    return PhoneNumberProviderModel;
});
//# sourceMappingURL=PhoneNumberProviderModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/PhoneNumberProviderModel.js
// module id = 88
// module chunks = 2